<ng-container>
  @if (isLoading) {
  <div class="container">
    <div class="indicator"></div>
  </div>
  }
</ng-container>
